import { ExternalLink, InternalLink, Line, P } from "@sorcery/ui";

import { Logo } from "~/components/atoms/Logo";
import {
  apiPath,
  cardsPath,
  collectionGuidePath,
  contactPath,
  decksPath,
  discordGroupPath,
  faqsPath,
  fbGroupPath,
  homePath,
  locatorPath,
  newsPath,
  playNetworkPath,
  preconsPath,
  rulebookPath,
  termsPath,
} from "~/utils/paths";

const FooterLinks = () => (
  <>
    <div className="mb-4">
      <h4 className="decoration-primary mb-4 text-sm font-semibold uppercase text-white underline underline-offset-4">
        Curiosa
      </h4>
      <ul className="font-medium text-gray-400">
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={cardsPath}
        >
          <li className="mb-1">Cards</li>
        </InternalLink>

        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={decksPath}
        >
          <li className="mb-1">Decks</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={collectionGuidePath}
        >
          <li className="mb-1">Collecting</li>
        </InternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={preconsPath}
        >
          <li className="mb-1">Precon Decks</li>
        </InternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={apiPath}
          target="_blank"
        >
          <li className="mb-1">API</li>
        </ExternalLink>
      </ul>
    </div>
    <div className="mb-4">
      <h4 className="decoration-primary mb-4 text-sm font-semibold uppercase text-white underline underline-offset-4">
        Resources
      </h4>
      <ul className="font-medium text-gray-400">
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          target="_blank"
          href={locatorPath}
        >
          <li className="mb-1">Store Locator</li>
        </ExternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          target="_blank"
          href={playNetworkPath}
        >
          <li className="mb-1">Play Network</li>
        </ExternalLink>

        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          // biome-ignore lint/style/useTemplate: <explanation>
          href={newsPath + "/dust-in-sorcery-contested-realm"}
          target="_blank"
        >
          <li className="mb-1">The Dust System</li>
        </ExternalLink>
        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={faqsPath}
        >
          <li className="mb-1">FAQs</li>
        </InternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={rulebookPath}
          target="_blank"
        >
          <li className="mb-1">Rulebook</li>
        </ExternalLink>
      </ul>
    </div>

    <div className="mb-4">
      <h4 className="decoration-primary mb-4 text-sm font-semibold uppercase text-white underline underline-offset-4">
        Company
      </h4>
      <ul className="font-medium text-gray-400">
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          target="_blank"
          href={newsPath}
        >
          <li className="mb-1">News</li>
        </ExternalLink>

        <InternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={contactPath}
        >
          <li className="mb-1">Contact</li>
        </InternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={discordGroupPath}
          target="_blank"
        >
          <li className="mb-1">Discord</li>
        </ExternalLink>
        <ExternalLink
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={fbGroupPath}
          target="_blank"
        >
          <li className="mb-1">Community</li>
        </ExternalLink>
        <ExternalLink
          target="_blank"
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={"https://sorcerytcg.com/privacy"}
        >
          <li className="mb-1">Privacy</li>
        </ExternalLink>
        <ExternalLink
          target="_blank"
          className="transition-colors duration-150 ease-in-out hover:text-white"
          href={termsPath}
        >
          <li className="mb-1">T&C's</li>
        </ExternalLink>
      </ul>
    </div>
  </>
);

export const Footer = () => {
  return (
    <footer className="text-sm">
      <Line className="mb-8 mt-12" />
      <div className="container mx-auto h-full w-full px-8 py-8 lg:px-20">
        {/* <Line className="mt-12" /> */}
        <div className="my-8 mb-6 flex flex-col items-center justify-between lg:flex-row lg:items-start">
          <div className="mb-8 flex flex-col items-center lg:mb-0 lg:items-start">
            <div className="w-[12rem] cursor-pointer lg:-ml-2 lg:w-[14rem]">
              <InternalLink href={homePath}>
                <Logo />
              </InternalLink>
            </div>

            <P className="!mb-0 text-gray-400">
              <span>© 2024 by Erik's Curiosa Limited.</span>
              <span className="lg:hidden"> All Rights Reserved.</span>
            </P>
            <P className="hidden text-gray-400 lg:inline">All Rights Reserved.</P>
          </div>

          <div className="grid  grid-cols-3 gap-4 md:gap-6 lg:gap-8 xl:gap-10">
            <FooterLinks />
          </div>
        </div>
      </div>
    </footer>
  );
};
